import ExpressionPage from '../store/schema/ExpressionPage';
import createEmojiPickerViewState from '../utils/createEmojiPickerViewState';
import createGifPickerViewState from '../utils/createGifPickerViewState';
import expressionStore from 'owa-expressions-store/lib/store/expressionStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import { action } from 'satcheljs/lib/legacy';

export default action('initializeExpressionPickerViewState')(
    async function initializeExpressionPickerViewState() {
        expressionStore.expressionPickerViewState = {
            isOpen: false,
            isSearching: false,
            searchTerm: '',
            page: isFeatureEnabled('cmp-gifPicker') ? ExpressionPage.All : ExpressionPage.Emojis,
            wordToReplace: '',
            emojiPickerViewState: createEmojiPickerViewState(),
            gifPickerViewState: isFeatureEnabled('cmp-gifPicker')
                ? await createGifPickerViewState()
                : null,
            numSearchesToInsertEmoji: 0,
            emojiCategoryIndex: 0,
            source: null,
            shouldRestoreSelectionAfterInsertNode: false,
            paneType: null,
        };
    }
);
